import {AxiosError} from "axios";
import {
  MutationFunction,
  QueryFunction,
  QueryKey,
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "react-query";

interface QueryParam<T> {
  key: QueryKey; //string | [string, number] | [string, unknown];
  api: QueryFunction<T, QueryKey>;
  options?: UseQueryOptions<T, AxiosError>;
}

interface MutationParam<T1, T2> {
  api: MutationFunction<T1, T2>;
  options?: UseMutationOptions<T1, AxiosError, T2>;
}

export const useGetQuery = <T>(param: QueryParam<T>): UseQueryResult<T, AxiosError> =>
  useQuery(param.key, param.api, param.options);

export const useGetItemQuery = <T>(param: QueryParam<T>): UseQueryResult<T, AxiosError> =>
  useQuery(param.key, param.api, param.options);

export const useFilterQuery = <T>(param: QueryParam<T>): UseQueryResult<T, AxiosError> =>
  useQuery(param.key, param.api, param.options);

export const useAuthMutation = <T1, T2>(
  param: MutationParam<T1, T2>
): UseMutationResult<T1, AxiosError, T2> => useMutation(param.api, param.options);
export const useCreateMutation = <T1, T2>(
  param: MutationParam<T1, T2>
): UseMutationResult<T1, AxiosError, T2> => useMutation(param.api, param.options);

export const useRemoveMutation = <T1, T2>(
  param: MutationParam<T1, T2>
): UseMutationResult<T1, AxiosError, T2> => useMutation(param.api, param.options);

export const useUpdateMutation = <T1, T2>(
  param: MutationParam<T1, T2>
): UseMutationResult<T1, AxiosError, T2> => useMutation(param.api, param.options);

// note : SmokingScully Add - 복사 기능
export const useCopyMutation = <T1, T2>(
  param: MutationParam<T1, T2>
): UseMutationResult<T1, AxiosError, T2> => useMutation(param.api, param.options);
